import $ from 'jquery';
import i18n, { t }  from '../../i18n/i18n.js';
import View from '../../../controls/View.js';
import MessagePopupView from '../../../controls/MessagePopupView.js';
import MainTabbedArea from '../../views/MainTabbedArea.js';
import ImportFromCampaignPopup from '../../popups/ImportFromCampaignPopup.js';
import app from '../../App.js';

/**
 * @const
 * @type {number}
 */
var TIME_SECTION_COUNT = 3;

var template =
    '<label class="sectioned-label"><input type="checkbox" data-name="timetable_always" /><span>{campaign_edit.timetable.timetable_always}</span></label>' +
    '<table class="timetable-table"><thead></thead><tbody></tbody></table>';

var CampaignEditTimeTablePage = View.extend({

    events: {
        'change input,select,textarea': 'onFieldChange',
        'change table.timetable-table select': 'markUnusedRows'
    },

    initialize: function (options) {
        var that = this;

        that.options = options = options || {};

        var $cornerButtons = that.$cornerButtons = $('<div class="corner-buttons">').appendTo(that.$el);

        $('<button class="duplicate-button">').text(t('campaign_edit.import_from_campaign')).click(that.importFromCampaignClicked.bind(that)).appendTo($cornerButtons);

        var $scrollPane = that.$scrollPane = $('<div class="scrollable-pane-content has-bottom-corner-actions">').appendTo($('<div class="scrollable-pane">').appendTo(that.$el));

        $('<h2>').text(t('campaign_edit.timetable.title')).appendTo($scrollPane);

        $scrollPane.append(i18n.processLocalizedString(template));

        $('<div class="corner-commit-actions">').append(
            $('<button class="action-save-button">').text(t('save')).click(that.saveClicked.bind(that))
        ).appendTo(that.$el);

        var $timetable = that.$timetable = $scrollPane.find('table.timetable-table');

        var $headerRow = $('<tr>').appendTo($timetable.find('>thead'));
        $('<th>').text(t('campaign_edit.timetable.day')).appendTo($headerRow);
        for (var slot = 0; slot < TIME_SECTION_COUNT; slot++) {
            $('<th>').text(slot === 0 ? t('campaign_edit.timetable.from_time') : '').appendTo($headerRow);
            $('<th>').text(slot === 0 ? t('campaign_edit.timetable.to_time') : '').appendTo($headerRow);
        }

        var timeOptionsHtml = '<option value="">' + t('campaign_edit.timetable.select_time') + '</option>';
        for (var hh = 0; hh < 24; hh ++) {
            for (var mm = 0; mm < 60; mm += 30) {
                var dt = new Date();
                dt.setUTCHours(hh);
                dt.setUTCMinutes(mm);
                timeOptionsHtml += '<option value="';
                timeOptionsHtml += (hh.toString().padStart(2, '0') + ':' + mm.toString().padStart(2, '0'));
                timeOptionsHtml += '">';
                timeOptionsHtml += i18n.formatDate(dt, 'UTC:' + t('date_formats.short_time'));
                timeOptionsHtml += '</option>';
            }
        }

        for (var day = 1; day <= 7; day++) {
            var $tr = $('<tr>').appendTo($timetable.find('>tbody'));
            $('<th>').text(t('campaign_edit.timetable.day_names.' + day)).appendTo($tr);

            for (var slot = 0; slot < TIME_SECTION_COUNT; slot++) {
                $('<select>').attr('data-name', 'timetable-day-' + day + '-from-' + slot).html(timeOptionsHtml).appendTo($('<td>').appendTo($tr));
                $('<select>').attr('data-name', 'timetable-day-' + day + '-to-' + slot).html(timeOptionsHtml).appendTo($('<td>').appendTo($tr));
            }
        }

        if (options.campaignId) {
            app.AlertUI.showLoader();
            that._isLoading = true;
            that.ajaxGet(app.apiUrl('campaigns/' + encodeURIComponent(options.campaignId)), { 'fields': 'id,name,project_id,timetable,timetable_always' })
                .always(function () {
                    app.AlertUI.hideLoader();
                    that._isLoading = false;
                })
                .then(function (data) {

                    that._campaignData = data;
                    that.options.projectId = data['project_id'];

                    that.loadFromData(data);
                })
                .fail(function (xhr, error) {
                    app.showXhrError(xhr, error);
                });
        }
    },

    hasTitleAreaVisible: true,
    titleAreaContent: function () {
        return [
            $('<h2 class="title">').text(this._campaignData ? this._campaignData['name'] : '...'),
            $('<a class="back">').text('< ' + t('campaign_edit.back')).attr('href', '/admin/management/projects/' + this.options.projectId + '/campaigns')
        ];
    },

    loadFromData: function (data) {
        var that = this;

        if (app.getMainView() instanceof MainTabbedArea) {
            app.getMainView().refreshTitleArea();
        }

        data['timetable'].sort(function (a, b) {
            if (a['day'] < b['day']) return -1;
            if (a['day'] > b['day']) return 1;
            if (a['from'] < b['from']) return -1;
            if (a['from'] > b['from']) return 1;
            if (a['to'] < b['to']) return -1;
            if (a['to'] > b['to']) return 1;
            return 0;
        });

        var usedUpSlotsByDay = { '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0, '7': 0 };

        that.$timetable.find('select').val('');

        data['timetable'].forEach(function (item) {

            if (usedUpSlotsByDay[item.day] >= TIME_SECTION_COUNT) return;

            var $from = that.$timetable.find('select[data-name=timetable-day-' + item.day + '-from-' + usedUpSlotsByDay[item.day] + ']');
            var $to = that.$timetable.find('select[data-name=timetable-day-' + item.day + '-to-' + usedUpSlotsByDay[item.day] + ']');

            usedUpSlotsByDay[item.day] ++;

            $from.val(item.from);
            $to.val(item.to);
        });

        that.$scrollPane.find('input[data-name=timetable_always]').prop('checked', !!data['timetable_always']);

        that.markUnusedRows();

        return that;
    },

    markUnusedRows: function () {
        var that = this;

        for (var day = 1; day <= 7; day++) {
            var used = false;
            for (var slot = 0; slot < TIME_SECTION_COUNT; slot++) {
                var $from = that.$timetable.find('select[data-name=timetable-day-' + day + '-from-' + slot + ']');
                var $to = that.$timetable.find('select[data-name=timetable-day-' + day + '-to-' + slot + ']');

                if ($from.val() || $to.val()) {
                    used = true;
                    break;
                }
            }

            that.$timetable.find('>tbody>tr:nth-child(' + day + ')').toggleClass('unused', !used);
        }

        return that;
    },

    render: function () {

        var that = this;

        return this;
    },

    saveClicked: function () {
        var that = this;

        that.$scrollPane.find('input.invalid,textarea.invalid,select.invalid').removeClass('invalid');

        var invalid = false;

        var data = {
            'timetable_always': !!that.$scrollPane.find('input[data-name=timetable_always]').prop('checked')
        };

        var timetable = data['timetable'] = [];

        for (var day = 1; day <= 7; day++) {
            for (var slot = 0; slot < TIME_SECTION_COUNT; slot++) {
                var $from = that.$timetable.find('select[data-name=timetable-day-' + day + '-from-' + slot + ']');
                var $to = that.$timetable.find('select[data-name=timetable-day-' + day + '-to-' + slot + ']');

                if ($from.val() && $to.val()) {
                    var timerow = {
                        'day': day,
                        'from': $from.val(),
                        'to': $to.val()
                    };

                    if (timerow.from > timerow.to) {
                        var tmp = timerow.from;
                        timerow.from = timerow.to;
                        timerow.to = tmp;
                    }

                    if (timerow.from === timerow.to) continue;

                    timetable.push(timerow);
                }
            }
        }

        if (invalid) {
            that.$scrollPane.find('input.invalid,textarea.invalid,select.invalid').first().focus();
            return;
        }

        var apiUrl = app.apiUrl('campaigns/' + encodeURIComponent(that.options.campaignId));

        app.AlertUI.showLoader(t('activity_indicator.saving'));

        that.ajaxJsonPost(apiUrl, data)
            .always(function () {
                app.AlertUI.hideLoader();
            })
            .then(function (response) {
                that._saveNeeded = false;

                new MessagePopupView({addClass: 'done', message: t('campaign_edit.call_settings.saved_prompt'), queue: true}).show();
            })
            .fail(function (xhr, error) {
                app.showXhrError(xhr, error);
            });

        return that;
    },

    onFieldChange: function () {
        this._saveNeeded = true;
        return this;
    },

    importFromCampaignClicked: function () {
        var that = this;

        if (that._isLoading) return that;

        if (that._importPopup) {
            that._importPopup.remove();
        }

        var popup = that._importPopup = new ImportFromCampaignPopup({ projectId: that.options.projectId });
        that.listenTo(popup, 'select', function (item) {

            that._isLoading = true;
            that.ajaxGet(app.apiUrl('campaigns/' + encodeURIComponent(item['id'])), { 'fields': 'id,name,project_id,timetable,timetable_always' })
                .always(function () {
                    that._isLoading = false;
                })
                .then(function (data) {
                    that.loadFromData(data);
                    popup.hide();
                })
                .fail(function (xhr, error) {
                    app.showXhrError(xhr, error);
                });

        });

        that._importPopup.show();

        return that;
    },

    hasUnsavedChanges: function() {
        return this._saveNeeded;
    },

    remove: function () {
        var that = this;

        if (that._importPopup) {
            that._importPopup.remove();
        }

        CampaignEditTimeTablePage.__super__.remove.apply(this, arguments);
    }

});

export default CampaignEditTimeTablePage
